  // Qty reset

(() => {
  const DEBUG_MODE = false; // 🛠️ Toggle to false to disable logs

  const log = (...args) => {
    if (DEBUG_MODE) console.log(...args);
  };
  
  document.addEventListener("change", (event) => {
    const target = event.target;
    if (!target.matches('input[type="radio"][name="option1"]')) return;

    const inputs = Array.from(document.querySelectorAll('input[type="radio"][name="option1"]'));
    const selectedIndex = inputs.findIndex(input => input.checked);

    log(`🥷 📡 Detected change on option1 → Index: ${selectedIndex}`);

    if (selectedIndex === 0) {
      const qtyInput = document.querySelector('.quantity-selector__value');
      if (qtyInput) {
        qtyInput.value = 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        log('🔁 Qty reset to 1 (No Case selected)');
      }
    }
  });

  log("🛡️ Qty auto-reset script initialized");
})();

// disabled variant selectors to show indicator ring
document.addEventListener('click', function (e) {
  if (!document.querySelector('.product-form__variants')) return;

  const option = e.target.closest('.cl-variant-option.disabled');
  if (!option) return;

  const value = option.getAttribute('data-value');
  const optionPosition = option.getAttribute('data-option-position');
  const input = option.querySelector(`input[type="radio"][data-option-position="${optionPosition}"]`);

  if (input) {
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});